import { getLookbookProductIdFromUrl } from '@app/logic/products';
import { useLocation } from 'react-router-dom';

export const useUrlLookbookProductId = () => {
  const { search } = useLocation();

  return getLookbookProductIdFromUrl(search);
};
